export default __webpack_public_path__ + "static/media/cincy.c1671636.png";